<template>
    <div class="AssignAuth  app-inner">
          <div class="public-btn-small flex align-cen posta" style="padding-left:0;left:200px;width:calc(100% - 200px)">
            <div class="public-btn-small-plan"  @click="$util.reback('/webenterpriseManage/courseSet')" style="margin-left:0">
                返回
            </div>
            </div>
             <div class="show_container">
            <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  基本信息
            </div>
        </div>
        <div class="appinfo">
            <div class="appname">课程：{{$route.query.courseName}}</div>
        </div>
        <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-userplus-fill"></i>  学习数据概况
            </div>
        </div>
        <!-- 人员 -->
                             <div class="quickOperate boxs">
                <div class="oprateBox flex align-cen">
                    <div class="createExam">
                        <div class="quickContainer">
                            <img src="../../../assets/images/ex4.png" alt="" class="oprateImg">
                            <div class="oprateText">总学习人数</div>
                        </div>
                        <div class="num">{{courseInfo.learnedNum || 0}}</div>
                        <el-tooltip class="item" effect="dark" content="累计至昨日，进行课程正常观看的人数总和，按照天进行更新" placement="top">
                        <span class="right-icon">
                            <i class="el-icon-warning"></i>
                        </span>
                          </el-tooltip>
                    </div>
                    <div class="createExam" >
                        <div class="quickContainer">
                            <img src="../../../assets/images/ex3.png" alt="" class="oprateImg">
                            <div class="oprateText">总完成人数</div>
                        </div>
                        <div class="num">{{courseInfo.finishNum || 0}}</div>
                            <el-tooltip class="item" effect="dark" content="累计至昨日，学完该课程的人数总和，按照天进行更新" placement="top">
                        <span class="right-icon">
                            <i class="el-icon-warning"></i>
                        </span>
                          </el-tooltip>
                    </div>
                     <div class="createExam" >
                        <div class="quickContainer" >
                            <img src="../../../assets/images/ex5.png" alt="" class="oprateImg">
                            <div class="oprateText">完课率统计</div>
                        </div>
                        <div class="num">{{courseInfo.finishRate || 0}}%</div>
                            <el-tooltip class="item" effect="dark" content="累计至昨日，学完该课程的人数/观看过该课程的人数，按照天进行更新" placement="top">
                        <span class="right-icon">
                            <i class="el-icon-warning"></i>
                        </span>
                          </el-tooltip>
                    </div>
                </div>
                      </div>
                                    <!-- 折线图 -->
                                 <div class="public-tit flex align-cen" ref="document" style="margin-top:20px">
                            <div class="public-tit-list">
                                <i class="icon-al-application"></i> 学习趋势
                            </div>
              </div>
                 <div class="chat-flex">
            <div class="student-detailds-chart">
                <div class="student-detailds-chart-head flex align-cen"> 
                    <span data-title="学习趋势图">学习趋势图</span>
                             <div class="businessList-filter-list flex align-cen" style="margin-left:auto">
                            <div class="label">自定义查询时间：</div>
                            <el-date-picker
                            v-model="value"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :picker-options="pickerOptions2"
                            @change="classSelect('')"
                            >
                            </el-date-picker>
                        </div>
                </div>
                 <div class="summaryOfTestPie">
                    <div class="exam-pr-pie">
                      <lineChart :option="LineChartOption" :barID="'lineID'"></lineChart>
                    </div>
                </div>
            </div>
                              </div>
                                         <div class="chat-flex">
            <div class="student-detailds-chart">
                <div class="student-detailds-chart-head flex align-cen"> 
                    <span data-title="完课绿趋势图">完课率趋势图</span>
                             <div class="businessList-filter-list flex align-cen" style="margin-left:auto">
                            <div class="label">自定义查询时间：</div>
                            <el-date-picker
                            v-model="value1"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :picker-options="pickerOptions2"
                            @change="classSelect(1)"
                            >
                            </el-date-picker>
                        </div>
                </div>
                 <div class="summaryOfTestPie">
                    <div class="exam-pr-pie">
                      <lineChart :option="LineChartOption1" :barID="'lineID1'"></lineChart>
                    </div>
                </div>
            </div>
                              </div>
                                                             <div class="public-tit flex align-cen" ref="document" style="margin-top:20px">
                            <div class="public-tit-list">
                                <i class="icon-al-application"></i> 学习详情
                            </div>
                            <div class="public-btn mft" @click="exportExcel(itemList)">导出</div>
                              </div>
                               <div class="App-tab" style="margin-top:16px">
                                <el-table
                                :data="itemList"
                                border
                                style="width: 100%"
                                :header-cell-style="{background:'#f7f8fa',color:'#333'}"
                                >
                                <el-table-column label="用户" align="center" prop="userName">
                      </el-table-column>
                         <el-table-column label="用户手机号" align="center" prop="loginName">
                      </el-table-column>
                      <el-table-column label="所属企业" align="center" prop="businessName">
                      </el-table-column>
                      <el-table-column label="来源" align="center" prop="">
                            <template slot-scope="scope">
                        <p>{{scope.row.orderSource || '-'}}</p>
                        </template>
                      </el-table-column>
                      <el-table-column label="累计学习时长" align="center" prop="">
                         <template slot-scope="scope">
                        <p>{{scope.row.totalDuration || '-'}}min</p>
                        </template>
                      </el-table-column>
                      <el-table-column label="本课程学习时长" align="center" prop="">
                         <template slot-scope="scope">
                        <p>{{scope.row.duration || '-'}}min</p>
                        </template>
                      </el-table-column>
                      <el-table-column label="学习进度" align="center" prop="">
                         <template slot-scope="scope">
                        <p>{{scope.row.progress}}</p>
                        </template>
                      </el-table-column>
                        <el-table-column label="首次学习时间" align="center" prop="firstTime">
                      </el-table-column>
                       <el-table-column label="完成时间" align="center" prop="">
                         <template slot-scope="scope">
                        <p>{{scope.row.finishTime || '-'}}</p>
                        </template>
                      </el-table-column>
                                </el-table>
                                 <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
                               </div>
             </div>

    </div>
</template>
<script>
import { overviewCou,lineData,lineData1,tabData} from "@/api/enterprise/index"; 
import lineChart from "@/components/lineTemolate/index.vue"; //折线图图组件
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
import exportExcel from '../../../utils/exportExcel.js' //导出数据公共方法
export default {
    name:'AssignAuth',
    components:{
        lineChart,
        paginaTion
    },
    data() {
        return {
            itemList:[],
            starTime:'',
            endTime:'',
            value:'',
            starTime1:'',
            endTime1:'',
            value1:'',
             LineChartOption:{},
             LineChartOption1:{},
            loading:false,
            centerDialogVisible:false,
            centerDialogVisible1:false,
            courseInfo:{},
            relationList:[],
            appAuthAccountList:[],
            bussID:'',
            systesList:[],
             currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount:0,
            propObj:{},
                 pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        }
    },
    created () {
     const businessInfo = this.$locaStorage.setAge().get('businessInfo')
     const currentUserInfo = this.$locaStorage.setAge().get('currentUserInfo')
     this.bussID = businessInfo.id
        this.getappDetail()
        this.getLineData()
        this.getLineData1()
        this.getTabData()
    },
    methods: {
                //导出
          exportExcel(val){ 
             if(val.length !=0){
        let keyLisst = [] 
            for(let item in val){
             keyLisst.push( {
              '用户':val[item].userName, 
              '用户手机号':val[item].loginName, 
              '所属企业':val[item].businessName ,
              '来源':`${val[item].orderSource}  ?  ${val[item].orderSource} : '-'`,
              '累计学习时长':val[item].totalDuration,
              '本课程学习时长':val[item].duration,
              '学习进度':val[item].progress,
              '首次学习时间':val[item].firstTime ,
              '完成时间':val[item].finishTime || '-' ,
              } ) 
             }
         exportExcel.exportExcel(keyLisst,this.$route.query.courseName)
             }else{
                this.$message.error('未选择导出数据')
             }
        },
          classSelect(type){
        if(this[`value${type}`]){
             this[`starTime${type}`] = this[`value${type}`][0]
            this[`endTime${type}`]  = this[`value${type}`][1]
            }else{
              this[`starTime${type}`] = ""
              this[`endTime${type}`] = ""
            }
          type == 1 ? this.getLineData1() : type ==2 ? this.getSaleData() : this.getLineData()
      },
        getTabData(){
        tabData({id:this.$route.query.id,size:this.PageSize,current:this.currentPage,businessId:this.bussID})
          .then(res =>{
            this.itemList = res.data.records
            this.totalCount = res.data.total
          }) 
      },

                          // 子组件触发
      emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.getTabData()
      },
          getLineData(){
        lineData({id:this.$route.query.id,starTime:this.starTime,endTime:this.endTime,businessId:this.bussID})
        .then(res =>{
          if(res.data){
             
               let xData1 = [],
                    sData1 = []
            for (let key in res.data) {
                xData1.push(res.data[key].time)
                sData1.push({
                name:res.data[key].time,
                num:Number(res.data[key].learnedNum),
                value:Number(res.data[key].avgDuration),
                 itemStyle: {
                    color:   '#FF6969'
                  }
              })
               }
               this.LineChartOption = {
                 tooltip: {
                    trigger: 'axis',
                    formatter:function(params){
                    var str = '';
                     str = `${params[0].name}</br>学习人数：${params[0].data.num}</br>平均学习时长(分钟)：${params[0].value}`
                     return str
                  }
                },
                  grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                 xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: xData1
                },
                  yAxis: {
                    type: 'value'
                },
                 series: [
                    {
                    data: sData1,
                    type: 'line',
                    emphasis: {
                        focus: 'series'
                    },
                    areaStyle: {},
                    }
                ]
               }
          }
        })
      },
        getLineData1(){
        lineData1({id:this.$route.query.id,starTime:this.starTime1,endTime:this.endTime1,businessId:this.bussID})
        .then(res =>{
            let arr = res.data
          if(arr){
               let xData1 = [],
                    sData1 = []
            for (let key in arr) {
                xData1.push(arr[key].time)
                sData1.push({
                name:arr[key].time,
                num:arr[key].finishNum,
                value:arr[key].finishRate,
                 itemStyle: {
                    color:   '#FF6969'
                  }
              })
               }
               this.LineChartOption1 = {
                 tooltip: {
                    trigger: 'axis',
                    formatter:function(params){
                    var str = '';
                     str = `${params[0].name}</br>完成学习人数：${params[0].data.num}</br>完成率：${params[0].value}`
                     return str
                  }
                },
                  grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                 xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: xData1
                },
                  yAxis: {
                    type: 'value'
                },
                 series: [
                    {
                    data: sData1,
                    type: 'line',
                    emphasis: {
                        focus: 'series'
                    },
                    areaStyle: {},
                    }
                ]
               }
          }
        })
      },

          // 获取应用权限详情
      getappDetail(){
        overviewCou({id:this.$route.query.id,businessId:this.bussID},'enterprise')
            .then(res => {
            this.courseInfo = res.data
            })
            .catch(err => {
            })
      }
    },
}
</script>
<style lang="scss" scoped>
 .public-btn{
    min-width: 60px;
    cursor: pointer;
    color: #409eff;
    padding: 7px 10px;
    border-radius: 4px !important;
    text-align: center;
    border: none;
    background: #409eff;
    color: #fff;
        }
.AssignAuth{
    margin-bottom: 50px;
    .appinfo{
        padding: 30px;
        div{
            padding-bottom: 10px;
            font-size: 16px;
        }
    }
            .student-detailds-chart{
     background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    flex: 0 0 50%;
    max-width: 100%;
    .student-detailds-chart-head{
        padding: 9px 16px;
        border-bottom: 1px solid #e6e6e6;
        span{
            font-weight: 700;
            font-size: 18px;
            color: #333;
        }
       .yks-blue{
            background-color: #36aafd;
            color: white;
            border: 1px solid #36aafd;
            padding: 7px 20px;
            border-radius: 4px!important;
            margin-left: auto;
            cursor: pointer;
       } 
    }
       .summaryOfTestPie{
          margin-top: 36px;
          .exam-pr-pie{
            height: 400px;
            padding: 20px;
            border: 1px solid #e6e6e6;
            border-radius: 10px;
          }
        }
    }
       .quickOperate{
        .oprateTitle{
            font-size: 20px;
            color: #333333;
            margin: 12px 0 12px 0;
        }
        .oprateBox1{
          flex-wrap: wrap;
          justify-content:normal !important;
          .createExam{
            width: 21% !important;
          }
        }
        .oprateBox{
            margin-top: 20px;

            .createExam{
                position: relative;
                background-color: #ffffff;
                border-radius: 4px !important;
                border: solid 1px #eeeeee;
                width: 24%;
                padding: 10px 15px;
                margin: 0 22px 16px 0;
                cursor: pointer;
                // text-decoration: none;
                position: relative;
                .right-icon{
                    position: absolute;
                    display: block;
                    right: 10px;
                    top: 0px;
                    font-size: 20px;
                    cursor: pointer;
                }
                .num{
                   padding-left: 70px;
                    padding-top: 0px;
                    font-size: 25px;
                    font-weight: bold; 
                }
                .oprateImg, .oprateText{
                    display: inline-block;
                    vertical-align: middle;
                    margin-left: 10px;
                }
                .oprateImg{
                    max-width: 47px;
                    word-break: keep-all;
                }
                .oprateText{
                    font-size: 15px;
                    font-weight: normal;
                    color: #000000;

                }
            }
            .createExam1::before{
                border-bottom: 1px solid #36aafd;
                border-left: 1px solid #36aafd;
                transform-origin: 0 100%;
            }
             .createExam1::after{
                border-top: 1px solid #36aafd;
                border-right: 1px solid #36aafd;
                transform-origin: 100% 0;
            }
            .createExam2::before{
                border-bottom: 1px solid #ff962a;
                border-left: 1px solid #ff962a;
                transform-origin: 0 100%;
            }
             .createExam2::after{
                border-top: 1px solid #ff962a;
                border-right: 1px solid #ff962a;
                transform-origin: 100% 0;
            }
            .createExam3::before{
                border-bottom: 1px solid #d52b2a;
                border-left: 1px solid #d52b2a;
                transform-origin: 0 100%;
            }
             .createExam3::after{
                border-top: 1px solid #d52b2a;
                border-right: 1px solid #d52b2a;
                transform-origin: 100% 0;
            }
            .createExam:hover::after,.createExam:hover::before{
                transform: scale(1);
            }
        }
    }
}
::v-deep{
 .el-dialog {
    margin-top: 5vh !important;
 }   
 .authbtn{
    margin-top: 30px;
    justify-content: center !important;
 }
}
</style>